import { useMutation } from 'react-query';
import { httpService } from '../../../services/http.service';
import { BASE_URL } from '../../../constants/endpoints';
import { useStore } from '../../../store';

export const useActivateSavingBucket = () => {
  const { customerId } = useStore(state => state.user);
  return useMutation(
    'useActivateSavingBucket',
    async (): Promise<void> => {
      await httpService.post(`${BASE_URL}/api/v1/user/${customerId}/bucket/emergency`, { activate: true });
    },
  );
};
